import React, { useEffect, useState } from 'react';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { PartesAdapter } from '../../../../../infraestructure/persistence/rest/PartesAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { downloadFile } from '../../../../../shared/utils/download';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import FormularioAdjuntarContainer from '../Adjuntos/container';
import FormularioEditarPartes from './editar';

export const FormularioContainer = (props: any) => {
	let { tipo, handle, selected, onClose, perfilUser, user } = props;
	let [refreshAdjuntos,setRefreshAdjuntos] = useState(false);
	
	const api = new AdjuntosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let result: any;

	useEffect(()=>{setRefreshAdjuntos(false);},[props])

	const onUpdate = async (parte: any) => {
		if (handle) {
			handle(parte,refreshAdjuntos);
		}
	};

	const onAdjuntar = async (data: any) => {
		if (handle) {
			setRefreshAdjuntos(false);
			handle(data);
		}
	};

	const onDownLoadAdjuntos = async(idAdjunto: number, nombre: string) =>{
    try {
      		result = await api.DescargarAdjunto(idAdjunto);
			downloadFile(result.data,nombre)
			setRefreshAdjuntos(false);
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exception && alert("Error , " + exception.message);
		}
	}
	
	const onRemoveAdjuntos = async(data: any) =>{
		 // eslint-disable-next-line no-restricted-globals
		let todos = confirm("¿Eliminar el adjunto para todos los partes?");
		let requestData = {...data, ...{todosPartes: todos}}
    try {
			await api.EliminarAdjuntos(requestData);
			setRefreshAdjuntos(true);
			return true;
		} catch (e) {
			let exception = ServerErrorMessage(e);
      		exception && alert("Error , " + exception.message);
		}
  }

  const onChangeTypeAdjunto = async(dataAdjunto:any) =>{
	try {
		result = await api.ModificarTipoAdjunto(dataAdjunto);
		if(result.data && result.data!=="")
		{
			launchNotification({type:"success",title:"Modificación Adjunto",message:"Se ha modificado un adjunto."})
			setRefreshAdjuntos(true);
		}else{resultError()}
	} catch (e) {
		let exception = ServerErrorMessage(e);
		exceptionError(exception)
	}
}


	switch (tipo) {
		case 'U':
			return <FormularioEditarPartes onSave={onUpdate}  onDownLoad={onDownLoadAdjuntos} onRemoveAdjuntos={onRemoveAdjuntos} selected={selected} handleChangeTypeAdjunto={onChangeTypeAdjunto}
			refreshAdjuntos={refreshAdjuntos} onClose={onClose} perfilUser={perfilUser} user={user}/>;
		case 'A':
			return <FormularioAdjuntarContainer handle={onAdjuntar} selected={selected} onClose={onClose}/>;
		default: return null;
	}
};

export default FormularioContainer;